// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'peekpanel-arrow-left-solid';

export const Component = () => (
  <path d='M5.885 0s1.962.878 1.962 1.962v20.597a1.962 1.962 0 0 1-1.962 1.962H1.962A1.962 1.962 0 0 1 0 22.56V1.962C0 .878.878 0 1.962 0h3.923zm9.23 10.89h8.438c.589 0 .968.38.968.97 0 .613-.368 1.019-.968 1.019h-8.437l3.17 3.178c.25.143.347.416.347.743 0 .59-.379.97-.968.97a.94.94 0 0 1-.68-.287l-4.927-4.89-.093-.129c-.13-.263-.195-.434-.195-.603 0-.15.041-.248.195-.555l.093-.129 4.927-4.891a.946.946 0 0 1 .68-.286c.589 0 .968.38.968.97 0 .311-.115.58-.362.744l-3.157 3.177z' />
);

export const viewBox = '0 0 25 25';
